import React from 'react';

const NotFoundPage = () => (
    <div className="my-4">
        <h4>404 Page Not Found</h4>
    </div>
);

export default NotFoundPage;
